
import * as defaultImport from "@splunk/react-ui/Popover";
export * from "@splunk/react-ui/Popover";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
